import React, { Component } from "react";

import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";
import Apps_BannerTitle from "../layouts/apps/Apps_BannerTitle";
import CityXApp_Sidebar from "../layouts/apps/cityx-app/CityXApp_Sidebar";
import CityXAppNewBusiness_SiteContent from "../layouts/apps/cityx-app/CityXAppNewBusiness_SiteContent";

class CityXAppNewBiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "Services",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/apps",
          titlelink: "Aplikacije",
          border: "|",
          name: "CityX App - aplikacija tvog grada",
          heading: "CityX App",
        },
      ],
    };
  }
  render() {
    return (
      <div className="header-fixed page sidebar-left header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <Apps_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <CityXAppNewBusiness_SiteContent />
                <CityXApp_Sidebar />
              </div>
            </div>
            <Footer />
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default CityXAppNewBiz;
